/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const border = `1px solid ${colors.N40}`;

export const FileWrapper = styled.div({
  margin: `${gridSize() * 2}px 0`,
  '&:first-child': {
    marginTop: 0,
  },
  '&:last-child': {
    marginBottom: 0,
  },
  '& + &': {
    marginTop: 0,
  },
  '& + :not(&)': {
    borderTop: 'none',
  },
});

export const File = styled.div({
  border,
  borderRadius: '5px',
  overflow: 'hidden',
});

export const FileContent = styled.table({
  borderCollapse: 'collapse',
  borderSpacing: 0,
  font: token('font.body.UNSAFE_small'),
  fontFamily: token('font.family.code'),
  width: '100%',
});

export const FileContentWrapper = styled.div({
  overflowX: 'auto',
});

export const FileFooter = styled.footer({
  alignItems: 'center',
  background: token('color.background.neutral'),
  display: 'flex',
  minHeight: '3em',
  padding: `0 ${gridSize()}px`,
  borderTop: border,
});

export const FileHeader = styled.header({
  background: token('color.background.neutral'),
  display: 'flex',
  alignItems: 'center',
  padding: `${gridSize()}px`,
});
